import { Directive, Input, Output, Component, EventEmitter, OnInit, ViewChild } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import 'rxjs/add/operator/do';

declare function require(arg:string): any;

@Component({
  selector: 'mbx-login',
  templateUrl: './login.template.html',
  styleUrls   : ['./login.css'],
  providers: []
})
export class LoginComponent implements OnInit {

  // Se declara la variable para accesar a al info asignada en el mc padre
  private _dataLogin : any;
  private _loginTitle: any;
  private _loginImg  : any;
  private typeUser = [
    {name: 'Cliente', value: 1},
    {name: 'Administrador', value: 2},
  ]

  user_type = 2;
  popup;

  // @Input()  loginTitle = new EventEmitter();
  @Input()  username   : string;
  @Input()  password   : string;
  @Output() parLogin   : EventEmitter<string> = new EventEmitter<string>();
  @Output() credentials = new EventEmitter();

  @Input()
  set dataLogin(data: object) {
    // param -> data : resultado enviado desde el mc padre
    this._dataLogin = data;
  }  

  @Input()
  set imgLogo(data: any) {

    this._loginImg = String(data);
  }

  @Input()
  set loginTitle(data: any) {
    this._loginTitle = data;
  };

  ngOnInit() {
    this.inicial(); // inicializa el modal
  }

  constructor() {
    // const url_cas =  (<any>config).cas;
    // const url_api = (<any>config).ip;
    // console.log('config', (<any>config)),
    // console.log('url_cas', url_cas);
    // console.log('url_api', url_api);
    this.popup = true;
  }

  inicial() {
    // creamos un boton invisible para que al dar click se abra el modal con estos atributos data-toggle="modal" data-target="#modalTest"
    let btn = document.createElement('button');
    btn.setAttribute('data-toggle', 'modal');
    btn.setAttribute('data-target', '#modal');
    btn.setAttribute('id', 'modalButton');
    btn.style.display = 'none';
    document.body.appendChild(btn);
    // realizamos un click al boton creado
    document.getElementById('modalButton').click();
    // eliminamos el boton creado
    document.body.removeChild(btn);
  }

  /**
    Envia las credenciales mediante 'emit' 
  **/
  onClick() {

    // levantamos una alerta para indicar que se ha deshabilitado el login
    alert('Login deshabilitado, por favor contacte a su asesor de ventas. Gracias!');
    return;

    // let value = {
    //   username : this.username, 
    //   password: this.password,
    //   user_type : this.user_type
    // };
    
    // // this.parLogin.emit(value);
    // this.parLogin.emit(JSON.stringify(value));

  }

  close(){
		this.popup = false;
	}

};


// WEBPACK FOOTER //
// ../esscalo_funcionalidad/src/login/login.component.ts